import React from 'react'
import { msgid, ngettext, t } from 'ttag'

import { willExtendDeadline } from 'utils/sending'

import styles from './Invites.module.scss'
import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { useInvitesCareer } from './hooks'
import { SendTestsInvitationsModal } from 'components/modals/SendTestsInvitationsModal/SendTestsInvitationsModal'
import { SendTestsRemindersModal } from 'components/modals/SendTestsRemindersModal/SendTestsRemindersModal'

import { MailIcon } from 'components/shared/Icon/model'
import { InvitesTable } from './common/InvitesTable'
import { DeleteJobSeekerModal } from 'components/modals/DeleteJobSeekerModal/DeleteJobSeekerModal'
import { JobSeekerModal } from 'components/modals/AddJobSeekerModal/AddJobSeekerModal'
import { WORKSPACE_TEMPLATE_MODE } from 'components/modals/common/SendTestsMessageModal/common/SendTestsMessageForm/model'

export const Invites = () => {
  const { state, handlers } = useInvitesCareer()

  const {
    account,
    search,
    candidate,
    invitees,
    remindees,
    expired,
    deadline,
    isSendTestsInvitationsModalOpen,
    isSendTestsRemindersModalOpen,
    isOverviewModalOpen,
    isDeleteJobSeekerOpen,
    isNoInvitees,
    isNoRemindees,
    isNoExpired,
    isTargetingExpired,
  } = state

  const { name } = account

  const {
    setSearch,
    handleSendInvites,
    handleCopy,
    handleDelete,
    handleEdit,
    handleSendTestsMessage,
    handleSendTestsInvitationsModalClose,
    handleSendTestsInvitationsModalConfirm,
    handleSendTestsInvitationsModalOpen,
    handleSendTestsRemindersModalClose,
    handleSendTestsRemindersModalConfirm,
    handleSendRemindersOpen,
    handleSendExpiredOpen,
    handleOverviewModalOpen,
    handleOverviewModalClose,
    handleOverviewModalConfirm,
    handleDeleteJobSeekerClose,
    handleDeleteJobSeekerConfirm,
  } = handlers

  const remindersRecipients = candidate
    ? [candidate]
    : isTargetingExpired
      ? expired
      : remindees

  return (
    <>
      <Pane.Header className={styles.header}>
        <SearchWidget query={search} onChange={setSearch} />
        <Box>
          <Button
            className={styles.button}
            color="primary"
            icon={MailIcon}
            label={t`Send invites`}
            size="small"
            variant="filled"
            onClick={handleSendTestsInvitationsModalOpen}
            isDisabled={isNoInvitees}
          />
          <Button
            className={styles.button}
            icon={MailIcon}
            label={t`Send reminders`}
            size="small"
            variant="outlined"
            onClick={handleSendRemindersOpen}
            isDisabled={isNoRemindees}
          />
          {isNoExpired ? null : (
            <Button
              className={styles.button}
              icon={MailIcon}
              label={ngettext(
                msgid`Send to ${expired.length} past deadline`,
                `Send to ${expired.length} past deadline`,
                expired.length,
              )}
              size="small"
              variant="outlined"
              onClick={handleSendExpiredOpen}
            />
          )}
        </Box>
      </Pane.Header>

      <InvitesTable
        search={search}
        handleCopy={handleCopy}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        onSendTestsMessage={handleSendTestsMessage}
      />

      <JobSeekerModal
        isOpen={isOverviewModalOpen}
        candidate={candidate}
        onCancel={handleOverviewModalClose}
        onClose={handleOverviewModalClose}
        onConfirm={handleOverviewModalConfirm}
        {...{ candidate }}
      />

      <DeleteJobSeekerModal
        isOpen={isDeleteJobSeekerOpen}
        onCancel={handleDeleteJobSeekerClose}
        onClose={handleDeleteJobSeekerClose}
        onConfirm={handleDeleteJobSeekerConfirm}
      />

      <SendTestsInvitationsModal
        candidates={candidate ? [candidate] : invitees}
        onCancel={handleSendTestsInvitationsModalClose}
        onClose={handleSendTestsInvitationsModalClose}
        onConfirm={handleSendTestsInvitationsModalConfirm}
        isOpen={isSendTestsInvitationsModalOpen}
        mode={WORKSPACE_TEMPLATE_MODE}
        {...{ deadline, name }}
      />

      <SendTestsRemindersModal
        candidates={remindersRecipients}
        isExtending={willExtendDeadline(remindersRecipients)}
        onCancel={handleSendTestsRemindersModalClose}
        onClose={handleSendTestsRemindersModalClose}
        onConfirm={handleSendTestsRemindersModalConfirm}
        isOpen={isSendTestsRemindersModalOpen}
        mode={WORKSPACE_TEMPLATE_MODE}
        {...{ deadline, name }}
      />
    </>
  )
}
